import { Controller } from '@hotwired/stimulus';

// The browser's print dialog, from a button: the evidence sheet of /hq/pays
// (walk/HQ_PAYS.md). What prints is decided by the page's `print:` classes.
export default class extends Controller {
  print() {
    window.print();
  }
}
